"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const EmailTemplateVersionDetail_1 = require("../EmailTemplateVersionDetail");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.Versions = ({ template }) => {
    const { history } = use_react_router_1.default();
    return (react_1.default.createElement(reusables_1.QueryList, { itemName: "version", itemsKey: "emailTemplateVersions", countKey: "emailTemplateVersionsCount", item: EmailTemplateVersionDetail_1.EmailTemplateVersionDetail, queryVariables: {
            emailTemplateId: template && template.id,
        }, itemProps: () => {
            return { template };
        }, queryProps: {
            fetchPolicy: 'cache-and-network',
            query: graphql_1.emailTemplateVersions,
            variables: {
                emailTemplateId: template && template.id,
            },
        }, onClickNewBtn: () => {
            history.push(`/templates/${template && template.id}/new-version`);
        } }));
};
//# sourceMappingURL=Versions.js.map